exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-500[data-v-ce72ea3c],.font-700[data-v-ce72ea3c]{font-weight:700}#EditViewModal .modal-dialog[data-v-ce72ea3c],#VendorInfoModal .modal-dialog[data-v-ce72ea3c]{min-width:80%}", ""]);

// exports
